/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react';
import {
    makeStyles, // FormControlLabel,
    Grid,
    Divider,
    useMediaQuery,
    useTheme
} from "@material-ui/core";

import {
    Typography, Button,
} from "components/ui";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { AddressInput, BackStepButton, Loader } from 'components';
import { updatePersonalDetailsAction, uploadVerificationDocumentAction, uploadVerificationDocumentSetDataAction } from 'store/Verification/verificationActions';
import { updatePersonalDetailsState, uploadVerificationDocumentState } from 'store/Verification/verificationSelectors';
import NoDocInstructions from './NoDocInstructions';
import { initialState } from 'store/Verification/verificationReducer';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import intl from 'containers/Verification/Intl/VerificationIntl';
import { getItemFromLocalStorage } from 'utils/common';
import AddressProofUpload from 'containers/Common/AddressProofUpload';
import { uploadVerificationAddressProof } from 'store/Verification/varificationApi';
import { styledSnackbar } from 'containers/Common/Snackbar';

const useStyles = makeStyles((theme) => ({
    form: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column'
    },
    root: {
        // textAlign: 'center',
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        marginTop: theme.spacing(4),
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing(2),
        },
    },
    container: {
        padding: theme.spacing(0, 0, 4, 0),
        // justifyContent: 'space-between',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',


    },
    bodyTxt: {
        textAlign: 'center'
    },

    bodyTxtCenter: {
        marginBottom: theme.spacing(2),
        textAlign: 'center'
    },

    spanTxt: {
        color: 'black',
        fontWeight: 'bold'
    },
    inputDiv: {
        marginTop: theme.spacing(2),
        width: '100%'
    },
    rowInputDiv: {
        marginTop: theme.spacing(2),

        width: '100%',
        display: 'flex',
        alignItems: 'center'
    },
    radioInoutDiv: {
        marginTop: theme.spacing(2),
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    addressTitle: {
        textAlign: 'left',
        borderBottom: '1px solid black'
    },
    addressCheck: {
        textAlign: 'left',
    },
    continueBtn: {
        marginTop: theme.spacing(3),
    },
    stateAndZipDiv: {
        display: 'flex',
    },
    iconColor: {
        color: `${theme.palette.grey500}`,
        "&.Mui-checked": {
            color: `${theme.palette.accent.main} !important`
        },
    },
    underline: {
        textDecoration: 'underline'
    },
    txtRoot: {
        margin: theme.spacing(4, 1, 0, 1)
    },
    subtitleDiv: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    subtitle2: {
        ...theme.typography.subtitle2
    },
    divider: {
        backgroundColor: theme.palette.grey600
    },
    titleTxt: {
        marginTop: theme.spacing(3)
    },
    spacing: {
        width: theme.spacing(2)
    },
    commonFlex: {
        flex: 1,
        display: 'contents'
    },
    radioFlex: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        [theme.breakpoints.up(theme.showDrawerBreakPointUp)]: {
            justifyContent: 'center',
        }
    },
    uploadProofTitle: {
        marginTop: theme.spacing(3),
        textAlign: 'center'
    },
    proofHelperTxt: {
        margin: theme.spacing(1, 0, 0, 0),
        textAlign: 'center',
        color: theme.palette.accent.main
    },
    dontHaveTxt: {
        textDecoration: 'underline',
        textAlign: 'center',
        margin: theme.spacing(0, 0, 6, 0),
        cursor: 'pointer'
    },
    lastMainGrid: {

        margin: theme.spacing(3, 0, 2, 0),
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down(theme.showDrawerBreakPointUp)]: {
            justifyContent: 'space-between',
            marginTop: 'auto',
        }
    },
    btnDiv: {
        flex: 1,

    },
    uploadDivExternal: {
        margin: `${theme.spacing(3, 0, 2, 0)}`,
    },

}));

function ChangeCurrentAddress(props = {}) {
    const classes = useStyles();
    const { data = {}, onStepChange = () => null, updatePersonalDetailsState,
        updatePersonalDetails, 
        // uploadVerificationDocumentState, 
        // uploadVerificationDocument,
        // resetUploadVerificationDocument, 
        isLoading } = props;
    // eslint-disable-next-line no-unused-vars
    const getSavedFileData = getItemFromLocalStorage('pap', 'object');// primary address proof
    const [addressRequiredError, setAddressRequiredError] = useState(false);
    const [verificationDocData, setVerificationDocData] = useState({
        ...getSavedFileData
    });
    // eslint-disable-next-line no-unused-vars
    const [radioError, setRadioError] = useState([]);
    const [noDocAvailable, setNoDocAvailable] = useState(false);
    const theme = useTheme();
    const xsDownMatches = useMediaQuery(theme.breakpoints.down(theme.showDrawerBreakPointUp));
    const isLoadingData = isLoading || updatePersonalDetailsState.loading;
    const getSavedFormData = getItemFromLocalStorage('pa', 'object'); // primary address 
    const [residentialAddress, setResidentialAddress] = useState({
        // address_id: data.prs_address_residential.address_id || "",
        // address_line_1: data.prs_address_residential.address_line_1 || "",
        // address_line_2: data.prs_address_residential.address_line_2 || "",
        // landmark: data.prs_address_residential.landmark || "",
        // city: data.prs_address_residential.city || "",
        // state_code: data.prs_address_residential.state_code || "",
        // state_name: data.prs_address_residential.state_name || "",
        // postal_code: data.prs_address_residential.postal_code || "",
        address_id: data.prs_address_residential.address_id || "",
        address_line_1: "",
        address_line_2: "",
        landmark: "",
        city: "",
        state_code: "",
        state_name: "",
        postal_code: "",
        // country_code: data.prs_address_residential.country_code || data.entity_person_country_of_residence || "",
        ...getSavedFormData,
        country_code: data.entity_person_country_of_residence || "",
    });

    useEffect(() => {
        if (data.entity_person_country_of_residence && residentialAddress.country_code !== data.entity_person_country_of_residence) {
            setResidentialAddress((a => ({...a, country_code: data.entity_person_country_of_residence || ""})));
        }
    }, [data.entity_person_country_of_residence]);

    const onInvalid = (e) => {
        setAddressRequiredError(false);
        if (!verificationDocData.address_proof_front) {
            setTimeout(() => {
                setAddressRequiredError(true);
            }, 300);
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setAddressRequiredError(false);
        localStorage.setItem('pa', JSON.stringify(residentialAddress));
        // localStorage.setItem('pap', JSON.stringify(verificationDocData));
        if (!verificationDocData.address_proof_front) {
            setTimeout(() => {
                setAddressRequiredError(true);
            }, 300);
         return;
        }
        let address_verification_ref_id;
        try {
            address_verification_ref_id = await uploadVerificationDocumentHandler();
        } catch (error) {
            return;
        } 
        if (address_verification_ref_id) {
            updatePersonalDetails({
                personId: data.entity_person_id, token: data.continue_signup_token, body: {
                    primary_address_same_as_berbix: data.primary_address_same_as_berbix,
                    residentialAddress: { ...residentialAddress, address_verification_ref_id}
                },
                cb: onStepChange,
            });
        } else {
            if (!verificationDocData.address_proof_front_uploading_error && !verificationDocData.address_proof_back_uploading_error ) {
                styledSnackbar.error("Error uploading files, Please try again");
            }
        }
    };

    const onDontHaveDoc = () => {
        setNoDocAvailable(true);
    };
    const onFileChange = (e) => {
        const { name, files = [] } = e.target || {};
        setVerificationDocData(verificationDocData => ({ 
            ...verificationDocData, 
            [name]: files.length ? files[0] : null,
            [`${name}_loading`]: false,
            [`${name}_uploading_error`]: '',
        }));
        // setResidentialAddress(formData => ({ ...formData, 'address_verification_ref_id': response.document_id }));
    };
    // const uploadVerificationDocumentHandler = async (uploadData) => {
    //     // uploadVerificationDocument({ ...uploadData, personId: data.entity_person_id, token: data.continue_signup_token });
        
    //    const x = await uploadVerificationAddressProof({ 
    //        formData: {
    //            file: verificationDocData.address_proof_front
    //         },
    //         personId: data.entity_person_id, 
    //         token: data.continue_signup_token });
    //     const y = await  uploadVerificationAddressProof({ 
    //         formData: {
    //           file: verificationDocData.address_proof_back
    //         },
    //         personId: data.entity_person_id, 
    //         token: data.continue_signup_token });
    // };

    const uploadVerificationDocumentHandler = async () => {
        const { address_proof_front, address_proof_back } = verificationDocData;
        // const { entity_person_id, continue_signup_token } = data;
      
        const promises = [];

        setVerificationDocData(verificationDocData => ({ 
            ...verificationDocData, 
            address_proof_front_loading: true,
            address_proof_front_uploading_error: '',
            address_proof_back_uploading_error: ''
        }));
      
        // Upload front
        const frontPromise = uploadVerificationAddressProof({
          formData: { file: address_proof_front }
        });
        promises.push(frontPromise);
      
        // Upload back (only if available)
        let backPromise = null;
        if (address_proof_back) {
          backPromise = uploadVerificationAddressProof({
            formData: { file: address_proof_back }
          });
          setVerificationDocData(verificationDocData => ({ 
            ...verificationDocData, 
            address_proof_back_loading: true,
          }));
          promises.push(backPromise);
        }
      
        const [addressFrontUploadResult, addressBackUploadResult] = await Promise.all(promises);

        if (addressFrontUploadResult?.data?.document_id) {
            setVerificationDocData(verificationDocData => ({ 
                ...verificationDocData, 
                address_proof_front_loading: false,
            }));
        } else {
            setVerificationDocData(verificationDocData => ({ 
                ...verificationDocData, 
                address_proof_front_loading: false,
                address_proof_front_uploading_error: 'Error uploading this file',
            }));
        }

        const ids = [addressFrontUploadResult?.data?.document_id || ''];
        if (addressBackUploadResult?.data?.document_id) {
            setVerificationDocData(verificationDocData => ({ 
                ...verificationDocData, 
                address_proof_back_loading: false,
            }));
            ids.push(addressBackUploadResult?.data?.document_id)
        }  else if (addressBackUploadResult?.error) {
            setVerificationDocData(verificationDocData => ({ 
                ...verificationDocData, 
                address_proof_back_loading: false,
                address_proof_back_uploading_error: 'Error uploading this file',
            }));
        }
        return ids.join(", ");

      };

    const UnderLineTitle = ({ title }) => {
        return (<>
            <Typography className={classes.titleTxt} variant="subtitle2" color="grey700">{title}</Typography>
            <Divider className={classes.divider} />
        </>)
    }

    if (noDocAvailable) {
        return (<NoDocInstructions
            onGoBack={() => setNoDocAvailable(false)}
        />)
    }
    if (isLoading) {
        return <Loader />
    }
    return (<form onSubmit={handleSubmit} onInvalid={onInvalid} className={classes.form} >
        <div className={classes.root}>
            <Typography color="primary" variant="h6" className={classes.bodyTxtCenter}>
                <FormattedMessage {...intl.updateAddress} />
            </Typography>
            <div className={classes.container}>
                <UnderLineTitle title="Your Current Residential Address" />
                <AddressInput addressKey="residential" disableCountry={!!data.entity_person_country_of_residence} data={residentialAddress} onChange={setResidentialAddress} />
                <div>
                    <Typography variant="subtitle1" color="grey700" className={classes.uploadProofTitle} ><FormattedMessage {...intl.uploadAdd} /></Typography>
                    <Typography variant="caption" className={classes.proofHelperTxt} ><FormattedMessage {...intl.ex} /></Typography>
                    <AddressProofUpload
                        id={`address_proof_front`}
                        required
                        btnName="Upload a Document (Front)"
                        columnWise={xsDownMatches ? false : true}
                        name="address_proof_front"
                        onChange={onFileChange}
                        value={verificationDocData.address_proof_front || (residentialAddress.address_verification_ref_id ? 'address_proof_front' : '')}
                        previewUrl={verificationDocData.public_url || (residentialAddress.address_verification_ref_id ? 'address_proof_front' : '')}
                        showPreview
                        addressError={addressRequiredError}
                        uploadError={verificationDocData.address_proof_front_uploading_error}
                        uploadLoading={verificationDocData.address_proof_front_loading}
                        label= "Document (front)"
                        className={classes.uploadDivExternal}
                        // beforeSend={request => request}
                        // documentUploadState={uploadVerificationDocumentState}
                        // documentUpload={uploadVerificationDocumentHandler}
                        // resetDocumentUpload={resetUploadVerificationDocument}
                    />
                    <AddressProofUpload
                        id={`address_proof_back`}
                        btnName="Upload a Document (Back)"
                        columnWise={xsDownMatches ? false : true}
                        name="address_proof_back"
                        onChange={onFileChange}
                        value={verificationDocData.address_proof_back || (residentialAddress.address_verification_ref_id ? 'address_proof_back' : '')}
                        previewUrl={verificationDocData.public_url || (residentialAddress.address_verification_ref_id ? 'address_proof_back' : '')}
                        showPreview
                        uploadError={verificationDocData.address_proof_back_uploading_error}
                        uploadLoading={verificationDocData.address_proof_back_loading}
                        label= "Document (back)"
                        className={classes.uploadDivExternal}
                        hintText="Optional, if your document front is sufficient to validate address"
                        // beforeSend={request => request}
                        // documentUploadState={uploadVerificationDocumentState}
                        // documentUpload={uploadVerificationDocumentHandler}
                        // resetDocumentUpload={resetUploadVerificationDocument}
                    />
                    {data.truly_access === 1 ? <span onClick={onDontHaveDoc} className={classes.dontHaveTxt} ><Typography ><FormattedMessage {...intl.notHave} /></Typography></span> : null}
                </div>
                {isLoadingData ? <Loader /> : null}
                <Grid container className={classes.lastMainGrid}>
                    <BackStepButton disabled={isLoadingData || verificationDocData.address_proof_front_loading || verificationDocData.address_proof_back_loading} onClick={() => onStepChange('PERSONAL_DETAILS')} />
                    <Grid className={classes.btnDiv} md={6}>
                        <Button
                            disabled={isLoadingData || verificationDocData.address_proof_front_loading || verificationDocData.address_proof_back_loading}
                            title={"Submit"}
                            className={classes.btnDiv}
                            type="submit"
                            color="secondary"
                        />
                    </Grid>
                </Grid>
            </div>
        </div></form >)
}

const mapStateToProps = createStructuredSelector({
    updatePersonalDetailsState: updatePersonalDetailsState(),
    uploadVerificationDocumentState: uploadVerificationDocumentState(),
});

function mapDispatchToProps(dispatch) {
    return {
        updatePersonalDetails: data => dispatch(updatePersonalDetailsAction(data)),
        uploadVerificationDocument: data => dispatch(uploadVerificationDocumentAction(data)),
        resetUploadVerificationDocument: () => dispatch(uploadVerificationDocumentSetDataAction(initialState.documentUploadState))
    }
}

const withConnect = connect(
    mapStateToProps,
    mapDispatchToProps,
);

export default compose(
    withConnect,
    memo,
)(ChangeCurrentAddress);